import { useTranslation } from 'react-i18next';

export default function Portfolio() {
  const { t } = useTranslation();

  const portfolioItems = [
    {
      image:
        'https://static.readdy.ai/image/f2bd418b0bfbfafabfbde3d1f67690ab/f9c1e1e6a1ddc814ef2838e1eaa1a736.png',
      titleKey: 'portfolio.restaurante',
    },
    {
      image:
        'https://static.readdy.ai/image/f2bd418b0bfbfafabfbde3d1f67690ab/abd80640a7628dfb7853a8eb5e2e6d59.jpeg',
      titleKey: 'portfolio.hamburgueria',
    },
    {
      image:
        'https://static.readdy.ai/image/f2bd418b0bfbfafabfbde3d1f67690ab/ff184a1451aa72343af35befafc4b1ec.jpeg',
      titleKey: 'portfolio.steakhouse',
    },
    {
      image:
        'https://static.readdy.ai/image/f2bd418b0bfbfafabfbde3d1f67690ab/aec791a8eed0a5925ccd2a1325e31847.jpeg',
      titleKey: 'portfolio.sushi',
    },
    {
      image:
        'https://static.readdy.ai/image/f2bd418b0bfbfafabfbde3d1f67690ab/e8caa5340b095a68aaa0578329f61c36.jpeg',
      titleKey: 'portfolio.spa',
    },
    {
      image:
        'https://public.readdy.ai/ai/img_res/5bbcea9bd49d521ead995e430df8837a.jpg',
      titleKey: 'portfolio.pastelaria',
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=elegant%20wine%20bar%20interior%20with%20sophisticated%20ambient%20lighting%20and%20premium%20bottle%20display%2C%20luxury%20wine%20cellar%20atmosphere%20with%20dark%20wood%20accents%20and%20refined%20aesthetic%2C%20high-end%20sommelier%20space%20with%20contemporary%20design%20and%20professional%20photography%2C%20artisan%20wine%20tasting%20room%20with%20minimalist%20black%20and%20white%20decor&width=1080&height=1350&seq=port-007&orientation=landscape',
      titleKey: 'portfolio.wine',
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=modern%20architecture%20office%20building%20with%20glass%20facade%20and%20minimalist%20design%2C%20contemporary%20corporate%20headquarters%20with%20clean%20lines%20and%20premium%20materials%2C%20elegant%20business%20center%20exterior%20with%20sophisticated%20lighting%20at%20dusk%2C%20professional%20architectural%20photography%20with%20refined%20aesthetic&width=1080&height=1350&seq=port-008&orientation=landscape',
      titleKey: 'portfolio.architecture',
    },
  ];

  // Duplicar items para criar efeito de loop infinito
  const duplicatedItems = [...portfolioItems, ...portfolioItems];

  return (
    <section id="portfolio" className="py-24 lg:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6">
            {t('portfolio.titulo')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('portfolio.subtitulo')}
          </p>
        </div>
      </div>

      {/* Carrossel Infinito */}
      <div className="relative" data-product-shop="true">
        {/* Gradiente esquerdo */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        
        {/* Gradiente direito */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

        {/* Container do carrossel */}
        <div className="flex animate-scroll">
          {duplicatedItems.map((item, index) => (
            <div
              key={index}
              className="flex-shrink-0 mx-3 group cursor-pointer"
              style={{ width: '324px' }}
            >
              <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300" style={{ width: '324px', height: '405px' }}>
                <img
                  src={item.image}
                  alt={t(item.titleKey)}
                  title={`${t(item.titleKey)} - Olhar Criativo Portfolio`}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-5">
                    <h3 className="text-lg font-bold text-white">
                      {t(item.titleKey)}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
